
      // Enter leaves the field, so its blur change saves it; Shift+Enter
      // is a new line, and Enter that ends an IME composition is the
      // composition's. Enter never submits the form. The page puts the
      // comment in force back when what the field holds was not saved
      // and the render cannot change it (the order's comment emptied: it
      // stays), or when it changed while the person is in the field.
      export default {
        mounted() {
          this.handleEvent("material-comment-reset", ({id, value}) => {
            if (id === this.el.id) this.el.value = value
          })
          this.el.addEventListener("keydown", (e) => {
            if (e.key === "Enter" && !e.shiftKey && !e.isComposing) {
              e.preventDefault()
              this.el.blur()
            }
          })
        }
      }
    